// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"component-layout"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M21 3L16.5 3L12 3L12 21H16.5H21L21 3Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M12 3L7.5 3L3 3L3 21H7.5H12L12 3Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M12 3H3L3 21H12M12 3H21V21H12M12 3V12M12 21V12M12 12H3","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ComponentLayoutIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'component-layout',
    ref,
    icon: element,
  },
));

ComponentLayoutIcon.displayName = 'ComponentLayoutIcon';

export default ComponentLayoutIcon;
